import { UserCheck, Zap, SlidersHorizontal, Headset } from "lucide-react";
import { WHY_US } from "@/config/siteConfig";
import { Reveal } from "@/components/Reveal";

const ICONS = [UserCheck, Zap, SlidersHorizontal, Headset];

export const WhyUs = () => (
  <section id="pourquoi" className="border-t border-black/5 bg-white py-24 md:py-32" data-testid="why-us-section">
    <div className="mx-auto max-w-7xl px-4 md:px-8">
      <Reveal className="mb-14 max-w-2xl">
        <p className="mb-3 font-display text-xs font-bold uppercase tracking-[0.3em] text-gray-400">03 — Pourquoi nous choisir</p>
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-black sm:text-4xl lg:text-5xl">
          Une équipe qui vous écoute, vraiment
        </h2>
      </Reveal>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {WHY_US.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={item.title} delay={i * 0.1}>
              <div
                className="group h-full rounded-3xl border border-gray-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-jeem-yellow hover:shadow-lg"
                data-testid={`why-us-card-${i}`}
              >
                <span className="flex h-13 w-13 items-center justify-center rounded-full bg-jeem-yellow/20 transition-colors duration-300 group-hover:bg-jeem-yellow" style={{ height: 52, width: 52 }}>
                  <Icon className="h-6 w-6 text-black" />
                </span>
                <h3 className="mt-6 font-display text-lg font-bold text-black">{item.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-gray-600">{item.description}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
